module.exports = __webpack_public_path__ + "images/maps/locations/map@2x_7db99295237e9f78d58c38af2667b8fe.png";